import Link from "next/link";
import React, { useState } from "react";
import { AiOutlineCheck } from "react-icons/ai";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { Pagination, Autoplay } from "swiper/modules";
import Innerhtml from "../utils/Innerhtml";
import SeriesCard from "../utils/SeriesCard";
import WsrvImage from "../utils/WsrvImage";
import { GoArrowUpRight } from "react-icons/go";

export default function BookSection({ data }) {
  const defaultProduct = data?.advanceData?.data || "";

  const [filteredData, setFilteredData] = useState(defaultProduct);
  const [activeId, setActiveId] = useState(null);

  const handleData = (id) => {
    setActiveId(id);
    // console.log(id);
    const filterProduct = defaultProduct.filter(
      (item) => item.course?.id === id
    );
    setFilteredData(filterProduct);
  };


  return (
    <>
      {/* {JSON.stringify(filteredData)} */}
      <div className="testseries ">
        <section className=" pt-12">
          {/* Top Navigation Buttons */}
          <div className="container">
            {data?.advanceData?.course?.length > 0 && (
              <div className="flex flex-wrap justify-evenly gap-8 mb-12">
                {data?.advanceData?.course.map((item, ind) => (
                  <button
                    onClick={() => handleData(item.id)}
                    key={ind}
                    className={`px-7 py-1 rounded-xl text-xl font-bold transition-all border shadow-[0px_4px_10px_rgba(0,0,0,0.3)]
                  ${
                    activeId === item.id
                      ? "bg-yellow-500 border-yellow-600 text-[#EEFBFF] scale-103"
                      : "bg-[#FFD338] border-black text-gray-900 hover:bg-yellow-400"
                  }
                `}
                  >
                    {item.name}
                  </button>
                ))}
              </div>
            )}

          {filteredData.length > 0 ? (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-6">
                {filteredData.map((series, index) => (
                    <div className="border border-[#C3A3A3] lg:rounded-none rounded-md p-4 bg-white  flex flex-col min-h-[200px] md:min-h-[260px]">
                        <div className="flex flex-col lg:flex-row   gap-6 flex-grow">
                          <div className=" xl:w-48 lg:w-36 ">
                            <WsrvImage
                              src={series?.thumb || series?.linkedProduct?.thumb || "https://i.filecdn.in/844twof/book1-1756379148330.jpg"}
                              alt={series?.course?.name || "Book"}
                              preset="thumb"
                              width={180}
                              height={240}
                              sizes="(max-width: 768px) 50vw, 180px"
                              className="w-full h-full object-cover"
                            />
                          </div>

                          <div className="">
                            <div className="flex md:flex-col flex-row justify-between md:justify-start md:gap-0 gap-4">
                              <h3 className="text-[#163758] text-xl xl:text-2xl font-bold leading-snug">
                                {series?.course?.name}
                                <span className="text-[#000000] block text-lg xl:text-lg font-medium">
                                  {series?.course?.name}
                                </span>
                              </h3>
                              <p className="text-[#CF6335] font-bold text-xl lg:text-2xl mt-2">
                                ₹ {series?.cost || series?.linkedProduct?.cost}
                              </p>
                            </div>
                            <Link
                              href={`/courses/details/${
                                series?.uri || series?.linkedProduct?.uri
                              }`}
                              className="text-[#555] md:text-base m-auto md:m-0 text-lg lg:text-lg py-3 lg:py-8 mt-4 flex items-center gap-1 self-start"
                            >
                              View details{" "}
                              <GoArrowUpRight className="text-[#CF6335] w-4 h-4 font-bold" />
                            </Link>
                          </div>
                        </div>
                      </div>
                ))}
              </div>
            ) : (
              <div className="flex flex-col items-center justify-center py-20">
                <div className="bg-gray-100 rounded-full p-6 shadow-md">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-16 w-16 text-gray-500"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M9 17v-2h6v2m2 4H7a2 2 0 01-2-2v-5h14v5a2 2 0 01-2 2zM7 9V7a5 5 0 0110 0v2"
                    />
                  </svg>
                </div>

                <h2 className="mt-6 lg:text-4xl text-2xl font-bold text-gray-800">
                  Available Soon...
                </h2>
                <p className="mt-2 text-gray-500 text-center max-w-md">
                  It looks like there are no products listed at the moment.
                  Please check back later or explore other categories.
                </p>
              </div>
            )}
          </div>



        </section>
      </div>
    </>
  );
}
